import { LAUNCH_TOKEN_KEY, LAUNCH_GOOGLE_ID_KEY, LAUNCH_PROFILE_KEY } from './launch.constants';

export const hasLaunchAuth = (): boolean =>
  !!localStorage.getItem(LAUNCH_TOKEN_KEY) && !!localStorage.getItem(LAUNCH_GOOGLE_ID_KEY);

export const clearLaunchAuth = (): void => {
  localStorage.removeItem(LAUNCH_TOKEN_KEY);
  localStorage.removeItem(LAUNCH_GOOGLE_ID_KEY);
  localStorage.removeItem(LAUNCH_PROFILE_KEY);
};
